import ProfilesApi from '@app/api/public/ProfilesApi';
import { useQuery } from 'react-query';

export const profileQueryKey = 'profile';

const useGetProfile = () => {
    return useQuery([profileQueryKey], async () => {
        return ProfilesApi.id();
    });
};

export default useGetProfile;
